import faIq from 'assets/IQLogos/iq-simplified-logo';
import cx from 'classnames';

import { useAIContext } from 'lib/common/contexts/AIContext/Context';
import IQModalHeader from 'lib/common/contexts/AIContext/components/IQModalHeader';
import IQStandAlone from 'lib/common/contexts/AIContext/components/IQStandAlone/IQStandAlone';
import { IQDisplayMode } from 'lib/common/contexts/AIContext/components/constants/IQDisplayMode';

import ClickableIcon from 'lib/common/components/ClickableIcon';
import Tooltip from 'lib/common/components/atoms/Tooltip';

import styles from './softphone-open-iq-modal-button.module.scss';

export default function SoftphoneOpenIQModalButton() {
  const {
    actions: { openIQModal, closeIQModal },
    state: { isIQModalOpen },
  } = useAIContext();

  const handleOpenIQModal = () => {
    openIQModal({
      customHeader: <IQModalHeader displayMode={IQDisplayMode.STAND_ALONE} />,
      content: <IQStandAlone displayMode={IQDisplayMode.STAND_ALONE} />,
      onClose: closeIQModal,
    });
  };

  return (
    <div className={styles['softphone-open-iq-modal-button']}>
      <Tooltip title="IQ" aria-label="Open IQ" placement="right" enterDelay={1000} ariaHidden>
        <ClickableIcon
          icon={faIq}
          size={18}
          onClick={handleOpenIQModal}
          color="aiPrimary"
          className={cx(styles['softphone-open-iq-modal-button__icon'], {
            [styles['softphone-open-iq-modal-button__icon--open']]: isIQModalOpen,
          })}
        />
      </Tooltip>
    </div>
  );
}
